import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../header";
import HorairesTimeline from "./horaires";
import Footer from "../footer";
import PageTitle from "../theme/components/pagetitle";
import Loader from "../loader";
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"

export default class Horaires extends Component {
    render() {
        if (this.props.loading) {
            return (
                <div>
                    <Loader/>
                </div>
            )
        }

        const context = this.props.context
        const {org, config} = context

        const title = t`Horaires de ${org.name}`
        const description = t`Horaires de ${org.name}`

        return (
            <div>
                <Meta context={context} title={title} description={description}/>
                <Header context={context}/>
                <PageTitle context={context} title={t`Horaires`} color="#0B98FA"/>
                <div className="container" style={{marginTop: 20, minHeight: "50vh"}}>
                    <HorairesTimeline context={context}/>
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}
